"use strict";

$(document).ready(function () {
  var satbsArray = document.getElementsByClassName("solv-available-times-by-state");
  if (satbsArray.length > 0) {
    Array.from(satbsArray).forEach(function (el) {
      // Available slots list controls
      var listControls = el.getElementsByClassName("slot-list-control");
      if (listControls.length > 0) {
        Array.from(listControls).forEach(function (listControl) {
          listControl.addEventListener("click", function (event) {
            event.preventDefault();
            var targetExpanded = event.target.getAttribute("aria-expanded");
            if (targetExpanded == "true") {
              event.target.setAttribute("aria-expanded", "false");
              event.target.innerHTML = "View All";
            } else {
              event.target.setAttribute("aria-expanded", "true");
              event.target.innerHTML = "View Less";
            }
          });
        });
      }
      var elements = {
        button: el.querySelector('[role="combobox"]'),
        dropdownlist: document.querySelector('[role="listbox"]')
      };
      var isDropdownOpen = false;
      var toggleDropdown = function toggleDropdown() {
        elements.dropdownlist.classList.toggle("show");
        isDropdownOpen = !isDropdownOpen;
        elements.button.setAttribute("aria-expanded", isDropdownOpen.toString()); // update the aria-expanded state
      };
      var handleKeyPress = function handleKeyPress(event) {
        event.preventDefault();
        var key = event.key;
        var openKeys = ["Enter", " "];
        if (openKeys.includes(key)) {
          toggleDropdown();
        }
      };
      if (elements.button) {
        elements.button.addEventListener("keydown", handleKeyPress);
        elements.button.addEventListener("click", toggleDropdown);
      }
    });
  }
});